<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikciler"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>

<div class="content_card_content">




<SuppliersTable 
:suppliers="data" 
:show_brand="true" 
display_page="suppliers" 
:loading="loading" 
:totalRecords="totalRecords"
@onPage="onPage"
@onSort="onSort"
@filter="filter"
:rows="limit"
:page="page"
@searchSupplier="searchSupplier"
></SuppliersTable>

</div>





</div>







</div>
</template>

<script>
export default {

  name: 'Suupliers',

  data () {
    return {
      data:[],
      loading:true,
      page:0,
      limit:10,
      totalRecords:0,
      sortField:"created_at",
      sortOrder:1,
      columns:[
      {
        type:"text",
        field:"name",
        header:"İsim",
        hide_on_mobile:false,
      },
      {
        type:"relation",
        field:"brand",
        relation_field:"name",
        header:"Marka",
        hide_on_mobile:false,
      }, 
      {
        type:"date",
        field:"created_at",
        header:"Eklenme Tarih",
        hide_on_mobile:true,
      },

      ]
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      this.loading = await true
      let data = await this.silentApiGet("suppliers/"+this.page+"/"+this.limit+"?sort_order="+this.sortOrder+"&sort_field="+this.sortField) 
      this.totalRecords = await data.meta.total
      this.data = await data.data
      console.log(this.data);
      this.loading = await false
      //await this.$store.dispatch('suppliers/setSuppliers',this.data)
    },
    async searchSupplier(searchterm)
    {
      if(searchterm || searchterm!=="")
      {  
        //let result = await searchterm.toUpperCase();
        this.loading = await true
        let data = await this.silentApiGet("suppliers/"+this.page+"/"+this.limit+"?search="+searchterm+"&sort_order="+this.sortOrder+"&sort_field="+this.sortField) 
        this.totalRecords = await data.meta.total
        this.data = await data.data
        console.log(this.data);
        this.loading = await false        
      }
      else
      {
        this.getData()
      }
    },
    async onPage(event)
    {
        console.log("onPage")
        console.log(event)
        this.page = await event.event.page
        this.limit = await event.event.rows
        await this.getData()
    },
     onSort(event)
    {
        console.log("onSort")
        console.log(event)
        if(event.sortField=="date")
        {
          this.sortField = "created_at"
        }
        else if(event.sortField=="brand")
        {
          this.sortField = "brand_id"
        }
        else
        {
          this.sortField = event.sortField
        }
        
        this.sortOrder = event.sortOrder
        this.getData()

    },
    filter(event)
    {
        console.log("filter")
        console.log(event)
    },
    
  }
};
</script>

<style lang="css" scoped>
</style>